export const educationData = [
    {
        id: 1,
        institution: 'Epitech Bénin - Coding Academy',
        course: 'Développement Fullstack',
        startYear: 'Juillet 2025',
        endYear: 'Juillet 2026',
    },
    {
        id: 2,
        institution: 'Udemy - Zero To Mastery',
        course: 'UI/UX Design & Web Design',
        startYear: 'Décembre 2023',
        endYear: 'Mai 2024',
    },
    {
        id: 3,
        institution: 'ENEAM Gbégamey',
        course: 'Licence en Analyse Informatique et Programmation',
        startYear: 'Octobre 2021',
        endYear: 'Décembre 2024',

    },
    {
        id: 4,
        institution: 'Collège Martin Luther King, Mènontin',
        course: 'BAC Série D',
        startYear: 'Octobre 2020',
        endYear: 'Juin 2021',

    },
];
